import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import moment from 'moment'

// import Loader from '../_common/Loader'
import ChatForm from './ChatForm'
import { fetchChat, resetActiveChat, setSupportStatus } from '../../actions'

export class ChatApp extends Component {
  componentDidMount () {
    this.props.fetchChat(this.props.match.params.id)
    this._scrollToBottom()
    // const chatList = document.querySelector('.chat_messages')
    // chatList.scrollTop = chatList.scrollHeight
  }

  componentDidUpdate () {
    this._scrollToBottom()
  }

  componentWillUnmount () {
    this.props.resetActiveChat()
  }

  _scrollToBottom = () => {
    this.messagesEnd.scrollIntoView({ behavior: 'smooth' })
  }

  _handleBackClick = () => {
    this.props.history.push(`/chat`)
  }

  _renderChatHeader () {
    if (this.props.activeChat && this.props.activeChat.roomData) {
      const { propertyName, roomNumber, userName } = this.props.activeChat.roomData
      return [
        <div key="property" className="property">{ propertyName } - {roomNumber}</div>,
        <div key="name" className="name bold">{ userName }</div>
      ]
    }
    // return <Loader key="loader" classname="loader_dot_circle chat_header_loader small"/>
    return null
  }
  _renderChat () {
    const messages = this.props.activeChat.messages
    if (messages) {
      const chatMessages = _.map(messages, (val, key) => {
        val.id = key
        return val
      })

      return chatMessages.map((message, index) => {
        if (index === chatMessages.length - 1) {
          return this._renderChatMessage(message, true)
        }
        return this._renderChatMessage(message)
      })
    }
    return null
  }
  _renderReadStatus (id, last) {
    if (last && id === this.props.activeChat.userId) {
      const status = this.props.activeChat.roomData.read ? '既読' : '未読'
      return <span>{`(${status})`}</span>
    }
    return <span></span>
  }
  _renderChatMessage (data, last) {
    const messageOwner = data.userId === this.props.activeChat.userId ? 'self' : 'interlocutor'
    return (
      <div className={`${messageOwner} message_container`} key={data.id}>
        {
          data.message
            ? <div className="message">{data.message}</div>
            : null
        }
        {
          data.image
            ? <div className="message img_container"><img onLoad={this._scrollToBottom.bind(this)} src={data.image} alt=""/></div>
            : null
        }
        <div className="date">
          { this._renderReadStatus(data.userId, last) }
          <span>{moment(data.timestamp).format('YYYY.MM.DD HH:mm')}</span>
        </div>
      </div>
    )
  }
  _renderCompleteButton () {
    if (this.props.activeChat && this.props.activeChat.roomData && this.props.activeChat.roomData.support_completed) {
      return <span className="btn reverse_red done" disabled>対応済</span>
    }
    return <button className="btn primary" onClick={() => this.props.setSupportStatus(this.props.match.params.id)}>対応済にセット</button>
  }

  _isSupportCompleted = () => {
    // ${this.props.activeChat.roomData.support_completed ? 'support_completed ' : null}
    if (this.props.activeChat && this.props.activeChat.roomData) {
      return this.props.activeChat.roomData.support_completed
    }
    return null
  }

  render () {
    if (
      !this.props.activeChat.roomData ||
      this.props.activeChat.loading
    ) {
      return (
        <div className="empty_chat" ref={(el) => { this.messagesEnd = el }}></div>
      )
    }
    return (
      <section className="chat_app">
        <div className="container">
          <div className="button_container">
            <button className="btn reverse_primary" onClick={this._handleBackClick}>戻る</button>
            { this._renderCompleteButton() }
          </div>
        </div>
        <div className="chat_container">
          <div className="chat_header flex column justify-center align-center">
            { this._renderChatHeader() }
          </div>
          <div className={`${this._isSupportCompleted() ? 'support_completed ' : ''}chat_main`}>
            <div className="chat_messages">
              { this._renderChat() }
              <div className="last_line" ref={(el) => { this.messagesEnd = el }}></div>
            </div>
            <ChatForm roomID={this.props.match.params.id}/>
          </div>
        </div>
      </section>
    )
  }
}

function mapStateToProps ({ user, activeChat }) {
  return { user, activeChat }
}

export default connect(mapStateToProps, { fetchChat, resetActiveChat, setSupportStatus })(ChatApp)



// WEBPACK FOOTER //
// ./src/components/Chat/ChatApp.js